import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';

@Component({
  selector: 'ppl-aor-waiver-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    ButtonComponent,
    DatePickerComponent,
    DropdownSelectComponent,
  ],
  providers: [DatePipe],
  templateUrl: './aor-waiver-form.component.html',
  styleUrl: './aor-waiver-form.component.css',
})
export class AorWaiverFormComponent implements OnInit {
  waiverForm!: FormGroup;
  validationErrors: Record<string, string> = {};

  waiverOptions = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];

  @Input() mode: 'add' | 'edit' = 'add';
  @Input() waiverData: any;
  @Output() cancel = new EventEmitter<any>();
  @Output() savedWaiver = new EventEmitter<any>();

  constructor(private fb: FormBuilder, private datePipe: DatePipe) {}

  ngOnInit(): void {
    this.waiverForm = this.fb.group({
      waiverId: [null],
      startDate: [''],
      endDate: [''],
      waiver: [''],
      comments: [''],
    });

    if (this.mode === 'edit' && this.waiverData) {
      const data = { ...this.waiverData };
      if (data.startDate && typeof data.startDate === 'string') {
        data.startDate = new Date(data.startDate);
      }
      if (data.endDate && typeof data.endDate === 'string') {
        data.endDate = new Date(data.endDate);
      }
      this.waiverForm.patchValue(data);
    }

    this.waiverForm.get('endDate')?.disable();
    this.waiverForm.get('startDate')?.valueChanges.subscribe(() => this.autoSetEndDate());
  }

  autoSetEndDate(): void {
    const startDate = this.waiverForm.get('startDate')?.value;
    if (startDate instanceof Date) {
      const endDate = new Date(startDate);
      endDate.setFullYear(endDate.getFullYear() + 1);
      this.waiverForm.get('endDate')?.setValue(endDate, { emitEvent: false });
    } else {
      this.waiverForm.get('endDate')?.setValue(null, { emitEvent: false });
    }
  }

  validate(): boolean {
    this.validationErrors = {};
    const v = this.waiverForm.getRawValue();
    if (!v.startDate) this.validationErrors['startDate'] = 'Please select Start Date.';
    if (!v.waiver) this.validationErrors['waiver'] = 'Please select Waiver.';
    return Object.keys(this.validationErrors).length === 0;
  }

  cancelEdit() {
    this.cancel.emit(true);
  }

  save() {
    if (!this.validate()) return;
    const data = this.waiverForm.getRawValue();
    const payload: Record<string, unknown> = {
      startDate: this.datePipe.transform(data.startDate, 'yyyy-MM-dd'),
      waived: data.waiver === 'Yes',
      comments: data.comments ?? '',
    };
    if (data.endDate) {
      payload['endDate'] = this.datePipe.transform(data.endDate, 'yyyy-MM-dd');
    }
    if (this.mode === 'edit' && data.waiverId) {
      payload['waiverId'] = data.waiverId;
    }
    this.savedWaiver.emit(payload);
    this.cancel.emit(true);
  }
}
